import { Button } from './ui/button';
import { Plus } from 'lucide-react';
import React from 'react';

interface ToolBarProps {
  title?: string | null;
  secondaryTitle?: string | JSX.Element;
  createButton?: boolean;
  buttonTitle?: string;
  handleClick?: () => void;
  handlePrint?: () => void;
  additionalButton?: React.ReactNode;
}

const ToolBar = ({
  title,
  handleClick,
  createButton = false,
  buttonTitle,
  additionalButton,
  secondaryTitle,
}: ToolBarProps) => {
  return (
    <div className="pb-6 w-full">
      <div className="flex flex-col gap-2 items-start" id="toolbar">
        <div className="flex flex-row justify-between w-full gap-6 items-start">
          <h1
            className="text-2xl font-semibold xs:text-2xl"
            style={{
              overflowWrap: 'anywhere',
            }}
          >
            {title}
          </h1>
          <div className="flex flex-row gap-4">
            {additionalButton && additionalButton}

            {createButton && (
              <Button
                onClick={handleClick}
                data-testid="create-button"
                className="p-3 hover:bg-[#12375C] w-fit h-[36px]"
              >
                <div className="flex flex-row items-center">
                  <Plus className="h-4" />
                  <span className="font-medium hidden sm:block">{buttonTitle}</span>
                </div>
              </Button>
            )}
          </div>
        </div>
        {secondaryTitle && secondaryTitle}
      </div>
    </div>
  );
};

export default ToolBar;
